<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}"><common-data name="appShortName_29"/>介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                文华财经旗下星格研究所的旗舰产品之一，面向专业投资机构，提供集成化、全流程的风险控制策略开发工具。
            </p>
            <p class="intent">
                股票投资方面，作为多因子估值数据库的量化应用示范平台，支持引用估值数据，以及宏观、市场情绪、财务等各类事件因子，来开发风险控制策略，提供了包括编写因子、可视化策略构建、回测报告等功能。另外，<common-data name="appShortName_29"/>提供实用性的风险控制策略案例。
            </p>
            <p class="intent">
                商品CTA方面，支持引用大宗商品的产业大数据，宏观、供给、需求、消费等因子，量化各类市场参与者的决策依据，仿真市场价格的形成机制，对各个商品做多因子分析，构建量化交易策略。
            </p>
            <p class="intent">
                <common-data name="appShortName_29"/>也内置了文华的AI大语言模型技术，引用文华财经的行业新闻数据库，AI技术做行情分析，撰写研究报告。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">12E套餐</p>
            <p>事件因子库：梳理出了盈利预测、二级市场、公告事件、机构调研、市场情绪、宏观数据、估值等多维度的股票开源因子，还从个股新闻资讯中挖掘出了各类事件因子，并不断上新；<br>
                事件因子分析：提供原创算法计算因子有效期、股价涨跌概率、因子分布分析功能；<br>
                股票价值管理策略：通过个股新闻事件，宏观经济、利率、另类数据等不同维度的因子搭建平衡表，确认股价变动方向，利空出现的情况下临时清仓，利空消失时恢复持仓，优化净值曲线；<br>
                商品研究：以宏观、供给、需求、消费各维度的价格影响因素构建平衡表，借期货因子对价格的影响仿真商品价格形成过程，探寻价格变动依据；<br>
                Excel插件：通过插件工具可对系统数据库中的产业数据、宏观经济数据、商品行情做导出分析或者二次加工，生成报告、可视化分析；<br>
                自有数据落库：支持用户数据落库，在软件中分析维护，与系统库联合构建期货因子和策略。
                </p>
            <a target="_blank" href="https://wh12.wenhua.com.cn/#/Buy">>>> 查看12E套餐更多功能</a>
            <!-- <br>
            <br>
            <p class="detail_title">量化投研</p>
            <p class="tent">量化编写平台：python语言平台，配合文华数据库，编写自由，数据丰富，云计算技术保证运算速度，提高研发效率。</p>
            <p class="tent">文华精选因子库：包含了基本面、市场交易和情绪3个大类14个子类的400多个精选因子。覆盖了当前量化领域的常见因子并持续更新。</p>
            <p class="tent">多因子策略：实现因子库和量化投资方法的融合，提供高效灵活的图表化多因子量化投研、组合优化管理和归因分析。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wh12.wenhua.com.cn/#/Download" target="_blank"><common-data name="appShortName_29"/></a>体验版了解功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用<common-data name="appShortName_29"/>的电脑配置要求：<br />
                · X86架构的4核CPU/8G内存（RAM），或更高配置；<br />
                · windows10、windows11等64位操作系统；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 332px;
}
.details_gn p.tent {
    
}
</style>